/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalItemTissAliases {
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  FIELD = 'field',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  PANEL_ITEM_TISS = 'panel-item-tiss',
  PANEL_OPME = 'panel-opme',
  PANEL_QUIMIO = 'panel-quimio',
  TEXT = 'text',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
}
export { ModalItemTissAliases };
